// inviteFriends 依赖的请求与原生桥接。用 fetch 实现，避免引入 Vue 3 / axios 多页构建。
import { API_BASE_URL } from '../config/api'

const BASE_URL = API_BASE_URL
const TIMEOUT = 5000

let token = null
let auth = null

export const isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream

export function getUrlParams() {
  const params = {}

  function assign(query) {
    if (!query) return
    query.split('&').forEach((item) => {
      if (!item) return
      const idx = item.indexOf('=')
      const rawKey = idx === -1 ? item : item.slice(0, idx)
      let rawVal = idx === -1 ? '' : item.slice(idx + 1)
      const hashIdx = rawVal.indexOf('#')
      if (hashIdx !== -1) rawVal = rawVal.slice(0, hashIdx)
      let key = rawKey
      let val = rawVal
      try {
        key = decodeURIComponent(rawKey)
        val = decodeURIComponent(rawVal)
      } catch (e) {
        key = rawKey
        val = rawVal
      }
      if (key) params[key] = val
    })
  }

  assign((window.location.search || '').replace(/^\?/, ''))
  const hash = window.location.hash || ''
  const q = hash.indexOf('?')
  if (q !== -1) assign(hash.slice(q + 1))
  return params
}

export function setAuth(value) {
  auth = value
}

export function setToken(value) {
  token = value
}

function buildHeaders() {
  const headers = {
    'Content-Type': 'application/json',
    'app-version': '1.7.3',
    language: 'en',
  }
  if (token != null && token !== '') headers['app-token'] = token
  if (auth != null && auth !== '') headers.Authorization = auth
  return headers
}

export const request = {
  get(url) {
    const controller = typeof AbortController !== 'undefined' ? new AbortController() : null
    const timer = setTimeout(() => {
      if (controller) controller.abort()
    }, TIMEOUT)

    return fetch(BASE_URL + url, {
      method: 'GET',
      headers: buildHeaders(),
      signal: controller ? controller.signal : undefined,
    })
      .then((response) => {
        return response.text().then((text) => {
          let data = {}
          try {
            data = text ? JSON.parse(text) : {}
          } catch (e) {
            data = { data: text }
          }
          if (!response.ok) {
            return Promise.reject(data)
          }
          if (data == null || typeof data !== 'object') {
            data = { data: data }
          }
          return Object.assign({}, data, { responseText: text })
        })
      })
      .then(
        (data) => {
          clearTimeout(timer)
          return data
        },
        (error) => {
          clearTimeout(timer)
          return Promise.reject(error)
        }
      )
  },
}

export const closePage = () => {
  try {
    if (isiOS) {
      window.webkit.messageHandlers.closePage.postMessage('')
    } else {
      window.YiYaJsObj.closePage()
    }
  } catch (error) {
    window.history.go(-1)
  }
}
